import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import dateTimeService from "app/services/date-time/dateTimeService";
import type { RawDate } from "app/UtilitiesAndConstants/types/dates";

type Props = Omit<ITableCellProps, "value"> & {
    value: RawDate;
    dateFormat: string;
    className?: string;
};

const FormattedDateCell = ({ value, dateFormat, className }: Props) => {
    const formattedDate = dateTimeService.formatWithMoment(value, dateFormat);

    return (
        <span
            className={className}
            data-automation-cell-value={value}
        >
            {formattedDate}
        </span>
    );
};

export default FormattedDateCell;
